import { DEFAULT_COMMUNITY_GALLERY_FILTERS } from '../constants'
import { threeDStudioStore } from '../index'

const update = (patch) => {
  const { communityGalleryFilters } = threeDStudioStore.getState()
  threeDStudioStore.setState({
    communityGalleryFilters: { ...communityGalleryFilters, ...patch },
  })
}

/**
 * Sets the community gallery free-text search query
 * @param {string} searchQuery - Search term
 */
export const setSearchQuery = (searchQuery) => {
  update({ searchQuery })
}

/**
 * Sets the selected community gallery category
 * @param {string} category - Category value (e.g. 'all', 'characters')
 */
export const setCategory = (category) => {
  update({ category })
}

/**
 * Sets the community gallery sort order
 * @param {string} sortOrder - One of the sort option values ('new', 'popular', 'trending')
 */
export const setSortOrder = (sortOrder) => {
  update({ sortOrder })
}

/**
 * Resets all community gallery filters and sort to defaults
 */
export const clearAllFilters = () => {
  threeDStudioStore.setState({
    communityGalleryFilters: { ...DEFAULT_COMMUNITY_GALLERY_FILTERS },
  })
}

/**
 * Counts active filters in the community gallery slice
 * @param {Object} [state] - Optional state object. If not provided, reads from store.
 * @returns {number} Number of active filters
 */
export const getFiltersCount = (state) => {
  const current = (state || threeDStudioStore.getState()).communityGalleryFilters
  let count = 0

  if (current.searchQuery !== DEFAULT_COMMUNITY_GALLERY_FILTERS.searchQuery) {
    count += 1
  }
  if (current.category !== DEFAULT_COMMUNITY_GALLERY_FILTERS.category) {
    count += 1
  }
  if (current.sortOrder !== DEFAULT_COMMUNITY_GALLERY_FILTERS.sortOrder) {
    count += 1
  }
  return count
}
